/* adds a fair amount to the bundle, so only include if necessary
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
*/

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";

import "./index.css";

import App from "./App";

ReactDOM.render(
	<React.StrictMode>
		<Router basename="/benefit-for-children">
			<App />
		</Router>
	</React.StrictMode>,
	document.getElementById("bfc-root")
);
